export const testimonials = [
  {
    name: "Monika Balcerek",
    role: "Właścicielka szkoły językowej",
    company: "8 lat doświadczenia",
    image: "https://liderbranzyedukacyjnej.pl/wp-content/uploads/2024/12/monika.jpg",
    quote: "Szkolenie mocno merytoryczne i bardzo praktyczne. Szczególnie część o marketingu w social media była dla mnie bardzo potrzebna - dokładne info jak prowadzić marketing, jak przygotować swój fanpage oraz analiza przykładów uczestników szkolenia. To było super wartościowe!"
  },
  {
    name: "Estera Białas",
    role: "Założycielka szkoły językowej",
    company: "Początkująca przedsiębiorczyni",
    image: "https://liderbranzyedukacyjnej.pl/wp-content/uploads/2024/12/estera.jpg",
    quote: "Skorzystałam ze szkolenia dla osób otwierających swój edu biznes. Przedstawiono na nim sporo ważnych informacji w jasny sposób. Dla mnie bardzo wartościowe były informacje o finansach w edu biznesie - jak to jest z podatkiem, jakie ustalić ceny. Wszystko zostało wyjaśnione i dzięki temu łatwiej było mi podjąć decyzje o otwarciu szkoły. Im więcej wiemy, tym mniej się boimy. Polecam gorąco skorzystać z wiedzy Olgi i Michała."
  },
  {
    name: "Laura Nicpoń",
    role: "Właścicielka szkoły językowej",
    company: "",
    image: "https://liderbranzyedukacyjnej.pl/wp-content/uploads/2024/12/Laura.jpg",
    quote: "Gdyby nie Olga i Michał nie byłabym w miejscu, w którym jestem teraz. Każdy produkt Lidera Branży Edukacyjnej jest niesamowitą bombą merytoryczną, wszystko jest praktyczne i do wdrożenia od zaraz. Doceniam również ich wsparcie na każdym kroku. Żadne moje pytanie nie jest pozostawione bez odpowiedzi. To niesamowite, jakie efekty mogę zaobserwować wdrażając to, co mi przekazują."
  },
  {
    name: "Magdalena Kaczanowska",
    role: "Właścicielka szkoły językowej",
    company: "Doświadczona edukatorka",
    image: "https://liderbranzyedukacyjnej.pl/wp-content/uploads/2024/12/Magdalena.jpg",
    quote: "Polecam kursy Olgi i Michała, są konkretne, praktyczne, oparte na ich autentycznych doświadczeniach. Udało mi się wprowadzić dzięki ich poradom pare zmian w mojej firmie. Zawsze tez podchodzą indywidualnie do zapytań. Ich ciągły rozwój tez jest na plus! Słowem profesjonalizm!"
  },
  {
    name: "Wiktoria Szubelak",
    role: "Właścicielka szkoły językowej",
    company: "",
    image: "https://liderbranzyedukacyjnej.pl/wp-content/uploads/2024/12/Wiktoria.jpg",
    quote: "Znakomite kursy i szkolenia dla branży edukacyjnej, nie tylko dla szkół językowych. Sporo przydatnej wiedzy, podanej w konkretny sposób, zero lania wody, sama praktyka. Polecam!"
  },
  {
    name: "Monika Ozon",
    role: "Właścicielka szkoły językowej",
    company: "",
    image: "https://liderbranzyedukacyjnej.pl/wp-content/uploads/2024/12/ozon-monika.jpg",
    quote: "Gdyby słownik języka polskiego pod pojęciami zawierał zdjęcia, to pod wyrazem \"profesjonalizm\" musiałyby się znaleźć fotografie Olgi i Michała 😉 Zgrany team, który w niesamowicie przejrzysty i bezpośredni sposób trafia do odbiorcy, a wszystko podane z lekkością i dawką ogromnej wiedzy, na której najbardziej mi zależało. Jeszcze raz dziękuję za nieocenione rady, które zastosuję w prowadzeniu mojego biznesu"
  },
  {
    name: "Monika Hołodowska-Ünaldı",
    role: "Właścicielka szkoły językowej",
    company: "",
    image: "https://liderbranzyedukacyjnej.pl/wp-content/uploads/2024/12/Monika-Holodowska-Unaldi-.jpg",
    quote: "Gorąco polecam współpracę z Olgą i Michałem. Ich kursy są doskonale przygotowane, a oni sami skarbnicą wiedzy i doświadczenia. Wiele zawdzięczam ich pomysłom, energii oraz motywacji do działania 🙂 🙂"
  }
] as const;